
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'productSet/save',
        method: 'post',
        data
    })
}

export function getSingle(data) {
    return request({
        url: 'productSet/getSingle',
        method: 'post',
        data
    })
}

export function getPageList(data) {
    return request({
        url: 'productSet/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'productSet/delete',
        method: 'post',
        data
    })
}

export function getAll(data) {
    return request({
        url: 'productSet/getAll',
        method: 'post',
        data
    })
}

export function getProductSetlist(data) {
    return request({
        url: 'productSet/getProductSetlist',
        method: 'post',
        data
    })
}